import {
    Box,
    Typography,
    Grid
} from '@mui/material'
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api'
import React, { useRef } from 'react'
import MapICON from '../../../assets/map-marker/map_marker.png'
import { isTablet } from 'react-device-detect'
import { useTranslation } from 'react-i18next'

const containerStyle = {
    width: '100%',
    height: '400px',
    borderRadius: '10px',
}

export const SMAppOurLocation: React.FC = () => {

    const { t } = useTranslation()
    
    const mapRef = useRef()
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: 'AIzaSyDpRhUxHc-FK0hWoIf8VeSSoIZDEPwQ3-A',
    })

    const data = [
        {
            'title': 'SHENMA CREDIT SDN BHD',
            'subTitle': '(1085407-K)',
            'content': t('t397'),
            'address1': '2, Jalan Muthu Palaniappan,',
            'address2': '14000 Bukit Mertajam, Penang',
            'tel': '04-5230033',
            'lat': 5.365299293288091,
            'lng': 100.45897016324261,
        },
        {
            'title': 'SHENMA CREDIT SDN BHD',
            'subTitle': '(1085407-K)',
            'content': t('t398'),
            'address1': 'Lot 5, Level 9, Menara Great Eastern 2,',
            'address2': '50, Jalan Ampang, 50450 KL',
            'tel': '03-92123838',
            'lat': 3.154283332997596,
            'lng': 101.70097738138006,
        },
        {
            'title': 'SHENMA CREDIT SDN BHD',
            'subTitle': '(1085407-K)',
            'content': t('t399'),
            'address1': 'No. 29-01, Jalan Molek 1/5A',
            'address2': 'Taman Molek, 81100 Johor Bahru, Johor',
            'tel': '07-2130303',
            'lat': 1.531672074916899,
            'lng': 103.79245320068152,
        },
    ]

    const renderDealerItem = (index: number) => {
        return (
            <Box sx={{
                width: '100%',
                borderRadius: 6,
                cursor: 'pointer',
            }}>
                {isLoaded ?
                    <GoogleMap
                        ref={mapRef}
                        mapContainerStyle={containerStyle}
                        center={{
                            lat: data[index]['lat'],
                            lng: data[index]['lng'],
                        }} zoom={15}>
                        <Marker
                            icon={MapICON}
                            position={{ lat: data[index]['lat'], lng: data[index]['lng'] }}
                        ></Marker>
                    </GoogleMap> : <Box sx={{ width: '100%', height: '400px', backgroundColor: '#F2F2F2' }}></Box>}
                <Typography fontWeight={700} fontSize={'20px'} color={'#141F39'} sx={{
                    paddingTop: '20px'
                }} paddingLeft={'12px'} paddingRight={'12px'}>
                    {data[index]['title']}
                    <span style={{
                        fontSize: '14px',
                        fontWeight: '700',
                        color: '#141F39'
                    }}>{data[index]['subTitle']}</span>
                </Typography>

                <Typography fontWeight={600} fontSize={'16px'} color={'#6B6B6B'} paddingTop={'0px'} paddingLeft={'12px'} paddingRight={'12px'}>
                    {data[index]['content']}
                </Typography>

                <Typography fontWeight={400} fontSize={'16px'} color={'#6B6B6B'} sx={{
                    paddingTop: '12px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                }}>
                    {data[index]['address1']}
                </Typography>
                <Typography fontWeight={400} fontSize={'16px'} color={'#6B6B6B'} sx={{
                    paddingTop: '6px',
                    paddingLeft: '12px',
                    paddingRight: '12px',
                }}>
                    {data[index]['address2']}
                </Typography>

                <Typography fontWeight={400} fontSize={'16px'} color={'#6B6B6B'} paddingTop={'12px'} paddingLeft={'12px'} paddingRight={'12px'}>
                    Tel: {data[index]['tel']}
                </Typography>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            backgroundColor: '#FFFFFF',
            paddingLeft: '12px',
            paddingRight: '12px',
            paddingTop: '60px',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Box>
                <Typography fontWeight={700} fontSize={'24px'} color={'#141F39'} textAlign={'center'}>
                    {t('t396')}
                </Typography>

            </Box>
            <Box sx={{ width: '100%', paddingTop: '40px' }}>
                <Grid container rowSpacing={4} columnSpacing={isTablet ? 2 : 0}>
                    {data.map((item, index) => (
                        <Grid item key={index} xs={isTablet ? 4 : 12}>
                            {renderDealerItem(index)}
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMAppOurLocation
